import { hydrate } from "svelte";
import { islandsOptions, rootComponent } from "@kestrel/internal/client";
import type * as Module from "@kestrel/entry";
import type { ServerResult } from "@kestrel/stores";
import { resolveComponentFromRouteId } from "../component/resolve.js";
import { createStores } from "../stores/index-universal.js";
import { noop } from "../../utils/function.js";
import {
  hydrateIslandsIfAllRegistered,
  propagateIslandsFromEntrypoint,
  registerIslandEntrypoint,
} from "../islands/islands.js";
import { createRootContext } from "../context/createRootContext.js";
import { entryAppIdAttribute, serverDataMime } from "../../utils/consts.js";
import { resolveAsyncData, resolveOnexAssignments } from "./entry-modules.js";

/**
 *
 */
export const add = islandsOptions ? registerIslandEntrypoint : noop;

/**
 *
 *
 *
 *
 */
export const start = (async (current) => {
  const container = current.parentElement;
  if (import.meta.env.DEV && !container) {
    throw new Error("current script element is not attached to a parent");
  }

  const ssrStateScript = container!.querySelector<HTMLScriptElement>(
    `script[type='${serverDataMime}'][${entryAppIdAttribute}]`,
  );
  if (import.meta.env.DEV && !ssrStateScript) {
    throw new Error("No ssr state script found by entryAppIdAttribute");
  }

  const ssrStateJson = decodeURIComponent(ssrStateScript!.textContent);
  const ssrState = JSON.parse(ssrStateJson) as ServerResult;

  if (import.meta.env.DEV && !ssrState.routeId && !ssrState.error) {
    throw new Error("Invalid ssr state, missing routeId");
  }

  /*                                                */
  /*                                                             */
  const stores = createStores(ssrState);

  /*                                                                       */
  const [resolvedComponent] = await Promise.all([
    resolveComponentFromRouteId(ssrState.routeId, ssrState.error),
    resolveAsyncData(ssrState, stores),
    resolveOnexAssignments(),
  ]);

  /*                                                               */
  stores.component.set(resolvedComponent);

  /*                                                                              */
  if (islandsOptions) {
    propagateIslandsFromEntrypoint(current);
    hydrateIslandsIfAllRegistered(stores, ssrState, resolvedComponent);
  }
  /*                                                                                */
  else {
    hydrate(rootComponent, {
      target: container!,
      props: { component: resolvedComponent[0] },
      context: createRootContext(stores),
    });
  }

  /*                                        */
  current.remove();
}) satisfies typeof Module.start;
